import script from "./AddNewAttendance.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewAttendance.vue?vue&type=script&setup=true&lang=js"

import "./AddNewAttendance.vue?vue&type=style&index=0&id=48693b20&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48693b20"]])

export default __exports__